export { default as ErrorBoundary } from "./ErrorBoundary";
export { TYPES } from "./types";

export function concatMessages(errors) {
  return errors.map((err) => err.message).join(", ");
}
